/** Plain-language explanation of the connected system. */
export const howItWorksFunctions = [
  {
    id: 'connect-knowledge',
    title: 'Connect knowledge',
    body: 'Organize sources, concepts and relationships so people can find relevant information and understand its origins. SyNeural’s Semantic Knowledge Platform maintains the connected knowledge behind the workspace.',
    link: { label: 'Explore connected knowledge', href: '/semantic-knowledge' },
    example: 'A researcher opens a finding and reads the exact passage it came from.',
  },
  {
    id: 'coordinate-work',
    title: 'Coordinate work',
    body: 'Bring records, requests, reviews and next steps into a clear workflow. Noetivra Workspace gives each user a focused view of their responsibilities, while shared services connect activity across the organization.',
    link: { label: 'Explore Noetivra', href: '/noetivra' },
    example: 'A caseworker sees a new support request, assigns it and records the outcome.',
  },
  {
    id: 'develop-capability',
    title: 'Develop capability',
    body: 'Connect assessment with feedback, purposeful practice and reassessment. The Capability module uses the Human Capability Framework and relevant CJI or NCJI methods to structure development programs.',
    link: { label: 'Explore human development', href: '/human-capability' },
    example: 'A learner receives feedback, completes a practice activity and returns to a new task.',
  },
]

export const configurationLayers = [
  { name: 'Core', body: 'The intended shared foundation for records, permissions, workflows, integrations and activity history.' },
  { name: 'Workspace', body: 'The visual interface: dedicated workspaces through which each person does their part of the work.' },
  { name: 'Modules', body: 'Reusable functional building blocks, switched on where a solution needs them.' },
  { name: 'Solutions', body: 'Configurations that combine the relevant modules and workflows for one field, such as Government or Clinical.' },
]

export const publicModules = [
  { name: 'Knowledge', purpose: 'Connect sources, concepts and reviewed findings.' },
  { name: 'Capability', purpose: 'Run assessment and development workflows.' },
  { name: 'Services', purpose: 'Coordinate requests, referrals, support plans and follow-up.' },
  { name: 'Credentials', purpose: 'Record and share scoped achievements and qualifications.' },
]

export const configurationStatus =
  'Interactive demos show these workspaces and workflows with fictional records. The shared Core and the module structure describe the production platform under development; solution-specific functions such as clinical review and citizen administration are configured alongside the shared modules.'
